import { selectStepChildren } from 'entities/step-children';
import { selectStepGroups } from 'entities/step-groups';
import { selectExperience } from 'entities/experiences';
import { selectSelected } from 'entities/selected';
import { getSurveyBlocks } from 'lib/block';
/**
 * Get all survey blocks from step children up to and including the current step
 * @param {State} state - redux state
 * @returns {Array} Array of survey blocks
 */
export function selectAllSurveyBlocksUpToCurrentStep(state) {
  const groupOrder = selectExperience(state)?.steps ?? [];
  const stepGroups = selectStepGroups(state);
  const stepChildren = selectStepChildren(state);
  const selected = selectSelected(state);

  // Get a list of step children in order up to and including the current step
  const orderedStepChildren = groupOrder
    .map(order => stepGroups[order])
    .flatMap(({ children }) => children);

  const currentStepChild = selected?.stepChild;
  const currentChildIndex = currentStepChild
    ? orderedStepChildren.indexOf(currentStepChild)
    : -1;

  const limitedStepChildren =
    currentChildIndex >= 0
      ? orderedStepChildren.slice(0, currentChildIndex + 1)
      : orderedStepChildren;

  return limitedStepChildren.flatMap(stepChildId => {
    const stepChild = stepChildren[stepChildId];
    return stepChild?.content ? getSurveyBlocks(stepChild.content) : [];
  });
}
